import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-view-itdcr',
  templateUrl: './modal-view-itdcr.component.html',
  styleUrls: ['./modal-view-itdcr.component.scss']
})
export class ModalViewItdcrComponent {
  @Input() itdcrNo!: string;
  @Input() showHistory: boolean = false;

  @Output() onClose = new EventEmitter<void>();

  onCloseModal() {
    this.onClose.emit();
  }
}
